import React, { useCallback, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import SelectorUI from './SelectorUI'
import useValueState from '../../utils/hooks/useValueState/useValueState'

export const titleTypes = {
  overline: 'overline',
  underline: 'underline',
}

function Selector({
  name,
  options,
  title,
  titleType,
  onChange = () => null,
  isClearable,
  isSearchable,
  defaultValue,
  ...rest
}) {
  const { value: optionSelected, handleChange } = useValueState(
    defaultValue || null,
  )
  const changeOption = useCallback(
    (value, action) => {
      if (isClearable && action.action === 'clear') {
        handleChange(null)
      } else {
        handleChange(value)
      }
    },
    [handleChange, isClearable],
  )
  useEffect(() => {
    if (defaultValue?.id !== optionSelected?.id) {
      handleChange(defaultValue)
    }
  }, [defaultValue])
  useEffect(() => {
    if (optionSelected?.id === 0) {
      onChange(optionSelected?.id)
    } else {
      onChange(optionSelected?.id || null)
    }
  }, [optionSelected])

  const selectProps = useMemo(
    () => ({
      options,
      value: optionSelected,
      onChange: changeOption,
      isClearable,
      isSearchable,
      defaultValue,
      name,
      id: rest?.id,
    }),
    [
      options,
      isClearable,
      isSearchable,
      optionSelected,
      changeOption,
      defaultValue,
      rest,
    ],
  )

  return (
    <SelectorUI
      selectorProps={selectProps}
      title={title}
      titleType={titleType}
      {...rest}
    />
  )
}

Selector.propTypes = {
  defaultValue: PropTypes.object,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  key: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.any),
  title: PropTypes.string,
  titleType: PropTypes.string,
}

export default Selector
